<template>
  <div class="modal fade contact_form_modal" id="commentModal" @click.self="$emit('close')">
    <div class="modal-dialog modal-dialog-centered modal-container--extra-large" role="document">
          <tabs v-if="showTabs" ref="tabs" :auth="auth" :building_id="building_id">
            <template v-slot:description>
              <tab name="Добавить комментарий" :selected="selectedTab.comment" v-if="auth">
                <comment-form
                    :user="user"
                    :parent_id="parent_id"
                    :building_id="building_id"
                    v-on:logout="logout"
                    v-on:profile="profile"
                    v-on:close="$emit('close')"
                    v-on:store-comment="$emit('store-comment')"
                >
                </comment-form>
              </tab>
              <tab name="Профиль" :selected="selectedTab.profile" v-if="auth">
                <user-profile :user="user" v-on:logout="logout" v-on:update-user="updateUser"></user-profile>
              </tab>
              <tab name="Войти" :selected="selectedTab.login" v-if="!auth">
                <auth v-on:login="login"></auth>
              </tab>
              <tab name="Регистрация" :selected="selectedTab.register" v-if="!auth">
                <register v-on:register-user="registerUser"></register>
              </tab>
            </template>
          </tabs>
    </div>
  </div>
</template>
<script>
import tabs from "./components/tabs";
import tab from "./components/tab";


import auth from "./components/auth";
import register from "./components/register"
import user from './components/user';
import UserProfile from "./components/user-profile"
import CommentForm from "./components/comment-form";
  export default {
    components:{
      'tabs':tabs,
      'tab':tab,
      'CommentForm':CommentForm,
      'auth': auth,
      'register':register,
      'user':user,
      'UserProfile':UserProfile,
    },
    props:{
      building_id:Number,
      auth:Boolean,
      user:Object,
      parent_id:Number,
    },
    data() {
      return {
        selectedTab:{
          comment: false,
          register:false,
          login:false,
          profile:false,
        },
        showTabs:false,
      }
    },
    methods: {
      profile() {
        this.$refs.tabs.selectProfile();
        for (var key in this.selectedTab) {
          if(key === 'profile') {
            this.selectedTab[key] = true;
          } else {
            this.selectedTab[key] =false;
          }
        }
      },

      login() {
        this.$emit('login')
            .$nextTick(() => {
              let auth = true;
              console.log(auth);
              this.checkAuth(auth);
            });
      },
      registerUser(data) {
        this.showTabs =false;
       this.$emit('register-user',data)
           .$nextTick(() => {
         let auth = true;
         console.log(auth);
         this.checkAuth(auth);
       })

      },
      checkAuth(auth) {
        if(auth) {

          for (var key in this.selectedTab) {
            if(key === 'comment') {
              this.selectedTab[key] = true;
            } else {
              this.selectedTab[key] =false;
            }
          }
        } else {
          for (var key in this.selectedTab) {
            if(key === 'login') {
              this.selectedTab[key] = true;
            } else {
              this.selectedTab[key] =false;
            }
          }
        }
        this.showTabs = true;

      },
      logout() {
        this.$emit('logout')
      },
      updateUser(data) {
        this.$emit('update-user', data);
      }
    },

    mounted() {
      this.$nextTick(() => {
        let auth = this.auth;
        this.checkAuth(auth);
      })

    }
}
</script>